// src/components/home/PostMenu.tsx
import React from 'react';
import { FaEllipsisH, FaLink, FaTrash, FaFlag } from 'react-icons/fa';
 
interface PostMenuProps {
  darkMode: boolean;
  postId: string;
  isOwnPost: boolean;
  isOptimistic: boolean;
  isOpen: boolean;
  onToggle: () => void;
  onShare: () => void;
  onDelete: () => void;
  onReport: () => void;
}
 
export const PostMenu: React.FC<PostMenuProps> = ({
  darkMode, isOwnPost, isOptimistic,
  isOpen, onToggle, onShare, onDelete, onReport,
}) => {
  const menuBg = darkMode ? '#0f2424' : '#f0fafa';
  const menuBorder = darkMode ? 'rgba(90,184,184,0.15)' : 'rgba(13,26,26,0.12)';
  const itemColor = darkMode ? 'rgba(240,250,250,0.7)' : '#0d1a1a';
  const itemHoverBg = darkMode ? 'rgba(90,184,184,0.08)' : 'rgba(13,26,26,0.05)';
 
  return (
    <div className="relative ml-2" data-post-menu>
      <button
        onClick={onToggle}
        className="p-2 rounded-lg transition-all"
        style={{ color: darkMode ? 'rgba(126,206,206,0.35)' : 'rgba(13,26,26,0.4)' }}
      >
        <FaEllipsisH style={{ fontSize: '13px' }} />
      </button>
 
      {isOpen && (
        <div
          className="absolute right-0 mt-2 w-44 rounded-xl overflow-hidden z-10"
          style={{
            background: menuBg,
            border: `1.5px solid ${menuBorder}`,
            boxShadow: '4px 4px 0 rgba(13,26,26,0.2)',
          }}
        >
          {/* Copy link */}
          <button
            onClick={onShare}
            className="w-full flex items-center gap-3 px-4 py-3 transition-all text-sm font-bold text-left"
            style={{ color: itemColor, letterSpacing: '0.5px' }}
            onMouseEnter={e => (e.currentTarget.style.background = itemHoverBg)}
            onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
          >
            <FaLink style={{ fontSize: '12px' }} />
            <span>COPY LINK</span>
          </button>
 
          {/* Report */}
          {!isOwnPost && (
            <button
              onClick={onReport}
              className="w-full flex items-center gap-3 px-4 py-3 transition-all text-sm font-bold text-left"
              style={{ color: '#e8a820', letterSpacing: '0.5px' }}
              onMouseEnter={e => (e.currentTarget.style.background = 'rgba(232,168,32,0.08)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
            >
              <FaFlag style={{ fontSize: '12px' }} />
              <span>REPORT</span>
            </button>
          )}
 
          {/* Delete */}
          {isOwnPost && !isOptimistic && (
            <button
              onClick={onDelete}
              className="w-full flex items-center gap-3 px-4 py-3 transition-all text-sm font-bold text-left"
              style={{ color: '#e05050', letterSpacing: '0.5px' }}
              onMouseEnter={e => (e.currentTarget.style.background = 'rgba(224,80,80,0.08)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
            >
              <FaTrash style={{ fontSize: '12px' }} />
              <span>DELETE</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};